module.exports = __webpack_public_path__ + "static/img/p8.ced8e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p8.png
// module id = swo4
// module chunks = 15